import { event } from './ga';

export const zipteamsIconClickEvent = () => {
  event({
    action: 'zipteams_icon_click_event',
    params: {
      'event_category': 'header',
      'event_label': 'zipteams icon click event'
    }
  })
}

export const logoutEvent = () => {
  event({
    action: 'logout_event',
    params: {
      'event_category': 'header',
      'event_label': 'logout event'
    }
  })
}